<div [formGroup]="filterFormGroup" class="personal-visit-filter no-field-space">
  <sc-flex [centered]="true">
    <mat-form-field class="grow" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="shared.tmc-table.filter"></sc-dictionary-label>
      </mat-label>
      <input matInput [maxLength]="255" name="filterText" formControlName="filterText">
    </mat-form-field>
    @for (item of scopeFilters; track item) {
      <sc-content-spacer [double]="true"></sc-content-spacer>
      <div class="item" [ngClass]="{'selected': item.selected}" (click)="applyQuickFilter(item)">
        <span class="{{item.icon}}"
        [matTooltip]="'Filter' | translate: [item.title, translationService.language, translationService.revision]"></span>
      </div>
    }
    <sc-content-spacer [double]="true"></sc-content-spacer>
    <mat-form-field class="custom-filter-field" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.customFilter"></sc-dictionary-label>
      </mat-label>
      <mat-select name="customFilter" formControlName="customFilter">
        <mat-option [value]="-1">
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.customFilter.option.none"></sc-dictionary-label>
        </mat-option>
        @for (filter of filters; track filter) {
          <mat-option [value]="filter.externalKey">
            <sc-dictionary-label [dictionaryKey]="filter.dictionaryKey"></sc-dictionary-label>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </sc-flex>
</div>
